import React, { createContext, useContext, useState, ReactNode } from 'react';

// Views
import LandingView from '../Views/Landing';
import DashboardView from '../Views/Dashboard';
import TestModeView from '../Views/TestMode';
import FirmwareView from '../Views/Firmware';
import ResetPasswordView from '../Views/Landing/Reset';

// Landing Views
import Login from "../Views/Landing/Login";
import Register from "../Views/Landing/Register";
import ForgotPassword from "../Views/Landing/ForgotPassword";
import Terminal from "../Views/Landing/Terminal";

export type NavigationContextType = {
    current: ReactNode;
    navigateTo: (view: String) => void;
    landingView: ReactNode;
    changeLandingView: (view: String) => void;
    showScience: boolean;
    setShowScience: (show: boolean) => void;
    entering: boolean;
    setEntering: (entering: boolean) => void;
};

// Create the context
const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

// Define the provider props
interface ThemeContextProviderProps {
    children: ReactNode;
}

// Create the provider component
export default function NavigationContextProvider({ children }: ThemeContextProviderProps) {

    const [current, setCurrent] = useState<ReactNode>(<div></div>);
    const [landingView, setLandingView] = useState<ReactNode>(<Login />);
    const [showScience, setShowScience] = useState<boolean>(false);
    const [entering, setEntering] = useState<boolean>(false);

    const navigateTo = (view: String) => {
        setCurrent(getView(view, 'main'));
    }
    
    const changeLandingView = (view: String) => {
        setLandingView(getView(view, 'landing'));
    }

    const getView = (view: String, type: String) => {
        console.log(view)
        if(type === 'main') {
            switch(view) {
                case 'landing':
                    return <LandingView />;
                case 'register':
                    changeLandingView('register');
                    return <LandingView />;
                case 'dashboard':
                    return <DashboardView />;
                case 'testMode':
                    return <TestModeView />;
                case 'firmware':
                    return <FirmwareView />;
                default:
                    return <LandingView />;
            }
        } else if(type === 'landing') {
            setShowScience(view !== 'start');
            switch (view) {
                case 'login':
                    return <Login />;
                case 'register':
                    return <Register />;
                case 'forgotPassword':
                    return <ForgotPassword />;
                case 'terminal':
                    return <Terminal />;
                case 'reset':
                    return <ResetPasswordView />;
                default:
                    return <Login />;
            }
        }
    }

    return (
        <NavigationContext.Provider 
            value={{ 
                current, 
                navigateTo,
                landingView,
                changeLandingView,
                showScience,
                setShowScience,
                entering,
                setEntering,
            }}
        >
            {children}
        </NavigationContext.Provider>
    );
}

// Create the hook
export function useNavigationContext() {
    const context = useContext(NavigationContext);
    if (context === undefined) {
        throw new Error('useNavigationContext must be used within a NavigationContextProvider');
    }
    return context;
}
